export const YOUTUBE_REGEXP = /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/(.+)$/;
export const VIMEO_REGEXP = /^(https?\:\/\/)?(www\.)?(vimeo\.com|player\.vimeo\.com\/(video)?)\/(.+$)/;
export const enum VideoType {
  YOUTUBE,
  VIMEO
};



// WEBPACK FOOTER //
// ./src/utilites/helpers/constants.ts